import { Helmet } from "react-helmet-async";

interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  url?: string;
  ogImage?: string;
  schema?: any;
  noindex?: boolean;
}

const DEFAULT_OG_IMAGE = "https://technostud-engineering.pages.dev/og-image.jpg";
const DEFAULT_URL = "https://technostud-engineering.pages.dev";

export function SEO({
  title = "Technostud Engineering — Engineering the Future",
  description = "Technostud Engineering is a global leader in smart manufacturing, turnkey engineering solutions, and advanced construction machinery.",
  keywords = "construction machinery, engineering, heavy equipment, batching plants, Technostud Engineering",
  url = DEFAULT_URL,
  ogImage = DEFAULT_OG_IMAGE,
  schema,
  noindex = false,
}: SEOProps) {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={url} />

      {noindex && <meta name="robots" content="noindex, nofollow" />}

      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />

      {/* Structured Data */}
      {schema && (
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      )}
    </Helmet>
  );
}
